// biome-ignore lint/performance/noBarrelFile: root entry point
export { upgrade } from './upgrade'
